import EventBus from '@/eventbus.js'
export default {
    getList(lang, per_page, page) {
        var filt = '?lang=' + lang + '&page=' + page +'&limit=' + per_page;
        return fetch("/api/defi/" + filt)
            .then((response) => {
            if(response.ok) {
                return response.json();
            } else {
                if (response.status == 401) {
                EventBus.$emit("NEED_AUTH");
                throw new Error('unauthenticated');
                }
                throw new Error(response.statusText);
            }
            })
            .then((myJSON) => {
                return myJSON
            })
            .catch(() => {
            })
  
    },
    save(lang, orig, hun, transl, mono, example) {
        var dat = {'lang':  lang, 'orig': orig, 'hun': hun, 'transl' : transl, 'mono' : mono, 'example' : example};
        return  fetch('/api/defi/', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dat),
          })
          .then((response) => {
            if(response.ok) {
                return true
            } else {
              if (response.status == 401) {
                EventBus.$emit("NEED_AUTH");
                throw new Error('unauthenticated');
              }
              throw new Error(response.statusText);
            }
          })
          .catch(() => {});
    },
    update (id, orig, hun) {
        var dat = {'orig': orig, 'hun': hun, 'id': id};
        return fetch('/api/defi/' + id, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(dat),
          })
          .then((response) => {
            if(!response.ok) {
              if (response.status == 401) {
                EventBus.$emit("NEED_AUTH");
                throw new Error('unauthenticated');
              }
              throw new Error(response.statusText);
            }
          })
          .catch(() => {});
    },
    delete(id) {
        return fetch('/api/defi/' + id, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
            }
          })
          .then((response) => {
            if(!response.ok) {
              if (response.status == 401) {
                EventBus.$emit("NEED_AUTH");
                throw new Error('unauthenticated');
              }
              throw new Error(response.statusText);
            }
          })
          .catch(() => {});
    },
    getTransl(lang, orig) {
        var dat = {'lang':  lang, 'orig': orig}
        return fetch('/api/transl/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dat),
            })
            .then((response) => {
                if(response.ok) {
                    return response.json()
                } else {
                    if (response.status == 401) {
                    EventBus.$emit("NEED_AUTH");
                    throw new Error('unauthenticated');
                    }
                    throw new Error(response.statusText);
                }
            })
            .catch(() => {});
    },
    getWebster(orig) {
      return fetch('/api/webster/' + orig, {
          method: 'GET'
          })
          .then((response) => {
              if(response.ok) {
                  return response.json()
              } else {
                  if (response.status == 401) {
                  EventBus.$emit("NEED_AUTH");
                  throw new Error('unauthenticated');
                  }
                  throw new Error(response.statusText);
              }
          })
          .catch(() => {});
  },
  login(email, password) {
        return fetch('/api/login', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({"email" : email, "password": password}),
        })
        .then((response) => {
            return response.ok ? response.json() : 0;
        })
        .then((data) => {
            if (data != 0){
            document.cookie = data['sid'];
            } else this.$buefy.toast.open({
                    duration: 5000,
                    message: `Helytelen felhasználónév vagy jelszó`,
                    position: 'is-bottom',
                    type: 'is-danger'
                });
            EventBus.$emit("AUTH_SUCCESS")
        })
    }
}
